module.exports = __webpack_public_path__ + "images/3609656f2fd7ff174456b1be5046e973b5d8806b2be37e492a4fc96242c6a6cc.svg";